import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { RouteConstant } from "src/app/core/_constants/route.constant";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { LogoutComponent } from 'src/app/shared/dialogs/logout/logout.component';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  show: boolean = true;

  Subscribefrom: FormGroup;
 // service: any;
 // fb: any;

  constructor(private router: Router,  private route: ActivatedRoute,private toastr: ToastrService,public dialogRef: MatDialog,  private service: ApiServicesService,private fb:FormBuilder, ) {

    this.Subscribefrom = this.fb.group({
      email: ['', Validators.required],
          
    });


   }

  ngOnInit(): void {

    if (window.innerWidth < 768) {
      this.router.events
        .subscribe(
          (event: any) => {
            if (event instanceof NavigationEnd) {
              if (event.url.includes('/' + RouteConstant.main + '/' + RouteConstant.moreProfile + '/' + RouteConstant.addUser) || event.url.includes('/' + RouteConstant.main + '/' + RouteConstant.moreProfile + '/' + RouteConstant.moreChangePassword)) {
                this.show = false;
              }
              else {
                this.show = true;
              }
            }
          });

      if (this.router.url == '/' + RouteConstant.main + '/' + RouteConstant.moreProfile + '/' + RouteConstant.addUser || this.router.url == '/' + RouteConstant.main + '/' + RouteConstant.moreProfile + '/' + RouteConstant.moreChangePassword) {
        this.show = false;
      }
      else {
        this.show = true;
      }

    }
    else {

    }
  }
  navigateToHelpCenter() {
    //window.location.href = `'/'${RouteConstant.main}'/'${RouteConstant.profile}'/'${RouteConstant.helpCenter}`;
    this.router.navigate(['/' + RouteConstant.main + '/' + RouteConstant.profile + '/' +  RouteConstant.helpCenter ]);
  }
  navigateToTermsOfUse() {
    //window.location.href = `'/'${RouteConstant.main}'/'${RouteConstant.profile}'/'${RouteConstant.helpCenter}`;
    // this.router.navigate(['/' + RouteConstant.main + '/' + RouteConstant.profile + '/' +  RouteConstant.termsofuse ]);
    this.router.navigate([RouteConstant.termsofuse]);

  }
  navigateToLicenses() {
    // this.router.navigate(['/' + RouteConstant.main + '/' + RouteConstant.profile + '/' +  RouteConstant.license ]);
    this.router.navigate([RouteConstant.license]);
    
  }
  navigateToFAQs() {
    //window.location.href = `'/'${RouteConstant.main}'/'${RouteConstant.profile}'/'${RouteConstant.helpCenter}`;
    this.router.navigate(['/' + RouteConstant.main + '/' + RouteConstant.profile + '/' +  RouteConstant.frequentlyaskedquestions ]);
  }
  navigateToAboutUs() {
    // this.router.navigate(['/' + RouteConstant.main + '/' + RouteConstant.profile + '/' +  RouteConstant.aboutUs ]);
    this.router.navigate([RouteConstant.aboutUs]);

  }
  navigateToPrivacyPolicy() {
    this.router.navigate([RouteConstant.privacypolicy]);

  }
  Feedbacks () {
    // window.location.href = `'/'${RouteConstant.main}'/'${RouteConstant.profile}'/'${RouteConstant.blogs}`;
     this.router.navigate(['/' + RouteConstant.main + '/' + RouteConstant.profile + '/' +  RouteConstant.frequentlyaskedquestions ]);
  }

  Complaints () {
    // window.location.href = `'/'${RouteConstant.main}'/'${RouteConstant.profile}'/'${RouteConstant.blogs}`;
     this.router.navigate(['/' + RouteConstant.main + '/' + RouteConstant.profile + '/' +  RouteConstant.helpCenter ]);
  }
 
  
  patnerUS () {
    // window.location.href = `'/'${RouteConstant.main}'/'${RouteConstant.profile}'/'${RouteConstant.blogs}`;
    //  this.router.navigate(['/' + RouteConstant.main + '/' + RouteConstant.profile + '/' +  RouteConstant.helpCenter ]);
     this.router.navigate([RouteConstant.Patnerwithus]);

  }
  

  
  postSubscribefrom() {
    
    const profileData = this.Subscribefrom.value;
    console.log('Form Data:', profileData);
  
    const payload = {
      ...profileData, // Include all form fields in the payload
    };
  
    const apiUrl = API_ROUTES.Account.Subscribe;
  
    this.service.post(payload, apiUrl, {}).pipe().subscribe((res) => {
      if (res.success == true) {
        this.toastr.success('Form submitted successfully');
        console.log('Form submitted successfully');
        this.dialogRef.open(LogoutComponent, {
          maxHeight: '100vh',
          width: '50%',
          data: {
            img: '../assets/images/new_img/Group.svg',
            heading: "You're all set! 🎉",
            para: "We'll keep you updated with the latest news, exclusive offers, and exciting content straight to your inbox."
          }
        })
        this.Subscribefrom.reset();     


      } else {
        this.toastr.error(res.message);
        console.log(res.message);
      }
    },
      (error) => {
        this.toastr.error(error.result.error);
        
      });
       
    }


  navigateToBlogs() {  

  
    // this.router.navigate([RouteConstant.blogs]);
        // this.router.navigate("/blogs");


  }
  openMap(event: Event) {
    event.preventDefault(); 
    window.open("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.355392289562!2d73.831158074652!3d18.512835369411597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf8ef9d3bf75%3A0x6325bfc1005d72a9!2sElectronica%20Finance%20Limited!5e0!3m2!1sen!2sin!4v1732014396313!5m2!1sen!2sin", '_blank');
}
 


}
 